"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var next_components_1 = require("@dotdev/next-components");
var Snippets = require("snippets");
var PasswordPopup = /** @class */ (function (_super) {
    __extends(PasswordPopup, _super);
    function PasswordPopup(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            loading: false
        };
        return _this;
    }
    PasswordPopup.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _this = this;
        setTimeout(function () { return _this.props.focusPassword(); }, 500);
    };
    PasswordPopup.prototype.render = function () {
        var _this = this;
        var form = this.props.form;
        return (React.createElement("div", { className: "fixed pin flex flex-col h-full-h w-full align-center justify-center bg-dark-navy text-arctic " + (this.props.visible ? "visible translate-y:0 transition-slow" : "invisible translate-y:200 transition") },
            React.createElement(Snippets.Link, { className: "hidden md:block mt-3-2 text-center pin-x pin-t text-sm fixed animation-ease-up", colour: "arctic", hoverColour: "grey-light", noHover: true, onClick: function () { return _this.props.handlePopup(); } },
                React.createElement(Snippets.Svg, { name: "chevron-up", height: 24, className: "block mx-auto animation-pulse-up" }),
                "Return to subscribe"),
            React.createElement(Snippets.Container, { width: "xxs", className: "text-center" + (this.state.loading ? " opacity-50 pointer-events-none" : "") },
                React.createElement(Snippets.Heading, { size: "h4", tag: "h2", className: "mb-2" }, "Enter store using password"),
                React.createElement(next_components_1.ShopifyNext.Components.Forms, { data: form, className: "w-full" },
                    React.createElement("div", { className: "w-full flex flex-col items-center" + (this.props.errors ? " animation-errors" : "") },
                        React.createElement(Snippets.Input, { type: "password", name: "password", placeholder: "Storefront password", errors: form.errors.form ? "Please try again" : null, autoCapitalize: "no", autoCorrect: "no", autoFocus: true, reverse: true, reference: this.props.passwordField, className: "flex-1 border border-arctic mb-1-6 w-7/10" }),
                        React.createElement(Snippets.Button, { style: "quarteriary", type: "submit", name: "commit", reverse: true, className: "w-14 h-4-8", onClick: function (event) { return _this.handleClick(_this); } }, "Continue")),
                    React.createElement("a", { href: "#", className: "inline-block md:hidden mt-4-2 md:mt-7-5 text-sm leading-looser", onClick: function () { return _this.props.handlePopup(); } }, "Return to subscribe")))));
    };
    PasswordPopup.prototype.handleClick = function (target) {
        this.setState({
            loading: true
        });
    };
    return PasswordPopup;
}(React.PureComponent));
exports.PasswordPopup = PasswordPopup;
